import './IconOk.css';
import React from 'react';
import { styled } from 'linaria/lib/react';
const IconOk = _ref => {
  let {
    width = 14.541,
    height = 11.425,
    className
  } = _ref;
  return /*#__PURE__*/React.createElement(StyledSVG, {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 14.541 11.425",
    className: className
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_102",
    "data-name": "Union 102",
    d: "M-4157.8,11167.161l-.169-.163,0,0-3.45-3.45,1.415-1.413,3.424,3.425,8.264-8.557,1.438,1.39-5.3,5.522-2.961,3.084.015.016-1.416,1.413Z",
    transform: "translate(4161.415 -11157)",
    fill: "#fff"
  }));
};
const StyledSVG = /*#__PURE__*/styled("svg")({
  name: "StyledSVG",
  class: "s1o9q6vg"
});
export default IconOk;